/**
 * The fixed sources of the film's relief (#140, 1.129.0), apart from
 * `terrainGround.ts` so that naming them loads no MapLibre: the film without
 * relief imports this file, and MapLibre comes only with the switch.
 *
 * **A fixed list and no setting**, as `MapSources`: a typed address would be
 * a foreign request in the author's browser, and the CSP names exactly these
 * two hosts (`server/.htaccess`, `tests/CspTest.php`).
 */
export const TERRAIN_STYLE = 'https://tiles.openfreemap.org/styles/liberty'
export const TERRAIN_HEIGHTS = 'https://s3.amazonaws.com/elevation-tiles-prod/terrarium/{z}/{x}/{y}.png'

/**
 * The licence note in the picture. OpenFreeMap asks for exactly this in print
 * and video; the heights need their source named. A note, not a sentence of
 * the app -- translated it would no longer be the note (`KEIN_TEXT`).
 */
export const TERRAIN_CREDIT = '© OpenMapTiles · Data from OpenStreetMap · Höhen: Mapzen/AWS Terrain Tiles'
